"use client";

import { useTheme } from "next-themes";
import { Toaster } from "sonner";

export default function SonnerToaster() {
  const { resolvedTheme } = useTheme();
  return (
    <Toaster
      theme={resolvedTheme === "dark" ? "dark" : "light"}
      position="top-center"
      richColors
      closeButton
      expand={false}
      offset={72}
    />
  );
}
